/* Easy Miles site script (em-pdp layout, defer). BUILD-SPEC 1.5 modules 1-10. No words typed here (labels: data-*). */
(function(){
'use strict';
var d=document,w=window,H=d.documentElement,
RM=!!(w.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches),
ROOT=(w.Shopify&&Shopify.routes&&Shopify.routes.root)||'/',
cur=null,annT=null,stIO=null,cdOpen=0,opener=null,cartJs=0;
function $(s,c){return (c||d).querySelector(s);}
function $$(s,c){return [].slice.call((c||d).querySelectorAll(s));}
function ga(e,a){return e.getAttribute(a);}
function lock(on){H.classList.toggle('em-lock',!!on);}
function after(el,fn){/* once el's transition ends; at once under reduced motion */
 if(RM||!el)return fn();
 var done=0,t;function f(e){if(done||(e&&e.target!==el))return;done=1;el.removeEventListener('transitionend',f);clearTimeout(t);fn();}
 el.addEventListener('transitionend',f);t=setTimeout(f,700);
}
function tabs(c){return c?$$('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea,summary,[tabindex]:not([tabindex="-1"])',c).filter(function(e){return e.offsetWidth||e.offsetHeight||e.getClientRects().length;}):[];}
function trap(e,L){
 if(e.key!=='Tab'||!L.length)return;
 var f=L[0],l=L[L.length-1],a=d.activeElement;
 if(L.indexOf(a)<0){e.preventDefault();(e.shiftKey?l:f).focus();}
 else if(e.shiftKey&&a===f){e.preventDefault();l.focus();}
 else if(!e.shiftKey&&a===l){e.preventDefault();f.focus();}
}
/* 7 pause/play: [data-em-motion] + .em-pp (words: data-l-pause / data-l-play); .is-off while off-screen */
var mqIO=('IntersectionObserver' in w)?new IntersectionObserver(function(es){es.forEach(function(e){e.target.classList.toggle('is-off',!e.isIntersecting);});}):null;
function initMq(c){if(mqIO)$$('[data-em-motion]',c).forEach(function(m){mqIO.observe(m);});}
function setPaused(box,p){
 box.classList.toggle('is-paused',p);
 var b=$('.em-pp',box),lp,ll;if(!b)return;lp=ga(b,'data-l-pause');ll=ga(b,'data-l-play');
 if(lp&&ll)b.setAttribute('aria-label',p?ll:lp);else b.setAttribute('aria-pressed',p);
}
/* 1 announcement: cross-fade every data-speed s; keeps going under the mouse (owner, 18 Oct); pauses on keyboard focus, hidden tab, pause button, editor select */
function showMsg(a,m){$$('.em-ann__m',a).forEach(function(x){x.classList.toggle('is-on',x===m);});}
function initAnn(){
 var a=$('[data-em-ann]'),ms,foc=0;if(!a||a._em)return;a._em=1;
 if(annT){clearInterval(annT);annT=null;}
 ms=$$('.em-ann__m',a);if(ms.length<2)return;
 /* keyboard focus only: a clicked/tapped play button keeps focus (QA 18 Oct) */
 a.addEventListener('focusin',function(e){var v=1;try{v=e.target.matches(':focus-visible');}catch(x){}if(!v)return;foc=1;var m=e.target.closest('.em-ann__m');if(m)showMsg(a,m);});
 a.addEventListener('focusout',function(){foc=0;});
 if(RM)return;
 annT=setInterval(function(){
  if(!d.contains(a))return clearInterval(annT);
  if(foc||d.hidden||a.classList.contains('is-paused')||a.hasAttribute('data-sel'))return;
  showMsg(a,ms[(ms.indexOf($('.em-ann__m.is-on',a))+1)%ms.length]);
 },(+ga(a,'data-speed')||30)*1000);
}
/* 1a dated message: [data-em-end] = last day YYYYMMDD (Brisbane, UTC+10, no daylight saving), the same setting
   the Liquid checks; for pages cached before the end. After it: the <template data-em-after> words, or no message */
function annEnd(){
 var a=$('[data-em-ann]'),t=new Date(Date.now()+36e6).toISOString().slice(0,10).replace(/-/g,''),ms,p;if(!a)return;
 $$('[data-em-end]',a).forEach(function(m){
  if(t<=ga(m,'data-em-end'))return;
  var x=$('template[data-em-after]',m),s=$('[data-em-txt]',m),h=x?x.innerHTML.trim():'';
  if(h&&s){s.innerHTML=h;m.removeAttribute('data-em-end');x.parentNode.removeChild(x);}else m.parentNode.removeChild(m);
 });
 ms=$$('.em-ann__m',a);
 if(!ms.length)return a.parentNode.removeChild(a);
 if(!$('.em-ann__m.is-on',a))ms[0].classList.add('is-on');
 if(ms.length<2){a.classList.add('em-ann--one');a.removeAttribute('data-em-motion');p=$('.em-pp',a);if(p)p.parentNode.removeChild(p);}
}
/* 1b gift minimum: snippets/em-gift-min prints "$75" / "$53" itself. Only a currency with no fixed number gets an empty [data-em-gift-wait] span ([data-em-gift-min] = cents in shop currency, data-pre "$", never a code): filled here via Shopify.currency.rate, rounded UP to a whole unit (same maths as em-cart.js) */
function giftMin(c){
 var C=w.Shopify&&Shopify.currency,r=C&&+C.rate;
 $$('[data-em-gift-wait]',c).forEach(function(s){var a=+ga(s,'data-em-gift-min'),u=ga(s,'data-cur');if(!a||!r||!u||C.active!==u)return;s.textContent=(ga(s,'data-pre')||'')+Math.ceil(Math.round(a*r)/100);s.removeAttribute('data-em-gift-wait');});
}
/* 2 header line once scrolled past the bar (or the 1px [data-em-top] marker) */
function initStuck(){
 if(stIO)stIO.disconnect();stIO=null;
 var hd=$('.em-hd'),t=$('.em-ann')||$('[data-em-top]');
 if(!hd||!t||!('IntersectionObserver' in w))return;
 stIO=new IntersectionObserver(function(es){hd.classList.toggle('is-stuck',!es[es.length-1].isIntersecting);});
 stIO.observe(t);
}
/* 3-4 phone menu <details class="em-nav"> and search <details class="em-srch">, both [data-em-det] */
function lab(s,o){var l=ga(s,o?'data-l-close':'data-l-open');if(l)s.setAttribute('aria-label',l);s.setAttribute('aria-expanded',!!o);}
function openDet(det,nf){
 if(cur)closeDet(1);closeCart(1);
 var hd=$('.em-hd'),p=$('[data-em-panel]',det),s=det.querySelector('summary'),f;
 if(hd)H.style.setProperty('--em-hd-bottom',Math.max(0,Math.round(hd.getBoundingClientRect().bottom))+'px');
 det.classList.remove('is-closing');det.classList.add('is-opening');det.open=true;
 if(p)p.offsetWidth;/* reflow: the slide starts from the closed place */
 det.classList.remove('is-opening');
 cur=det;lock(1);lab(s,1);
 f=det.classList.contains('em-srch')?$('input[type=search]',det):tabs(p)[0];if(f&&!nf)f.focus();
}
/* panel opened by the browser (find-in-page): same lock, labels, Escape */
d.addEventListener('toggle',function(e){var t=e.target;if(t.matches&&t.matches('[data-em-det]')&&t.open&&cur!==t&&!t.classList.contains('is-closing'))openDet(t,1);},true);
function closeDet(quiet){
 var det=cur,s;if(!det)return;cur=null;lock(0);
 s=det.querySelector('summary');lab(s,0);det.classList.add('is-closing');
 after($('[data-em-panel]',det),function(){if(det.classList.contains('is-closing')){det.open=false;det.classList.remove('is-closing');}});
 if(!quiet)s.focus();
}
var mq=w.matchMedia&&matchMedia('(min-width:1024px)');
function onMq(e){if(e.matches&&cur&&cur.classList.contains('em-nav'))closeDet(1);}
if(mq)mq.addEventListener?mq.addEventListener('change',onMq):mq.addListener(onMq);
/* 5 cart: shell #em-cart-drawer only in drawer mode and never on /cart; inside from /cart?view=em-drawer (G7) */
function cd(){return d.getElementById('em-cart-drawer');}
function bubble(n){
 if(n==null||isNaN(n))return;n=+n;
 $$('[data-em-cart-open]').forEach(function(a){var l=ga(a,n===1?'data-l-one':'data-l-many');if(l)a.setAttribute('aria-label',l.replace('[count]',n));});
 $$('[data-em-cart-count]').forEach(function(b){b.textContent=n;b.hidden=!n;});
}
function cartCount(){return fetch(ROOT+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){bubble(c.item_count);}).catch(function(){});}
function pick(h){/* never a whole page: only its #em-cart-body */
 if(/<html[\s>]/i.test(h)){var x=new DOMParser().parseFromString(h,'text/html').getElementById('em-cart-body');if(!x)throw 1;return x.outerHTML;}
 if(h.indexOf('emk-')<0)throw 1;return h;
}
function fetchCart(){
 var c=cd(),o={credentials:'same-origin'};if(!c)return Promise.reject();
 c.setAttribute('aria-busy','true');
 return fetch(ROOT+'cart?view=em-drawer',o).then(function(r){if(!r.ok)throw 0;return r.text();}).then(pick)
  .catch(function(){return fetch(ROOT+'cart',o).then(function(r){return r.text();}).then(pick);})
  .then(function(h){
   $('[data-em-cd-body]',c).innerHTML=h;c.removeAttribute('aria-busy');d.dispatchEvent(new CustomEvent('em:cart-drawn'));/* em-cart.js: free gift check */
   var a=$('[data-em-cart-js]'),u=a&&ga(a,'data-em-cart-js'),s;
   if(u&&!cartJs){cartJs=1;s=d.createElement('script');s.src=u;s.defer=true;d.head.appendChild(s);}
  });
}
function openCart(){
 var c=cd(),p;if(!c){location.href=ROOT+'cart';return;}
 if(cdOpen)return;if(cur)closeDet(1);
 cdOpen=1;if(!opener)opener=d.activeElement;
 p=$('.em-cd__panel',c);c.hidden=false;p.offsetWidth;c.classList.add('is-open');lock(1);p.focus();
 fetchCart().then(function(){var t=d.getElementById('emk-title');if(cdOpen&&t){if(!t.hasAttribute('tabindex'))t.setAttribute('tabindex','-1');t.focus();}})
  .catch(function(){location.href=ROOT+'cart';});
}
function closeCart(quiet){
 var c=cd(),o=opener;if(!cdOpen||!c)return;cdOpen=0;opener=null;
 c.classList.remove('is-open');lock(0);
 after($('.em-cd__panel',c),function(){if(!cdOpen)c.hidden=true;});
 if(!quiet&&o&&o.focus&&d.contains(o))o.focus();
}
d.addEventListener('em:cart-open',openCart);
d.addEventListener('em:cart-updated',function(e){
 var x=e.detail||{};
 if(x.item_count!=null)bubble(x.item_count);else cartCount();
 if(cdOpen&&x.source!=='cart')fetchCart().catch(function(){});
});
w.addEventListener('pageshow',function(e){if(e.persisted){if(cur)closeDet(1);closeCart(1);cartCount();}});
/* 6 highlight: .em-h em and .em-hl get .is-in once 60% visible (at once with reduced motion / no IO) */
var hlIO=(!RM&&'IntersectionObserver' in w)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');hlIO.unobserve(e.target);}});},{threshold:.6}):null;
function initHl(c){$$('.em-h em:not(.is-in),.em-hl:not(.is-in)',c).forEach(function(el){hlIO?hlIO.observe(el):el.classList.add('is-in');});}
/* 10 a #link or the page address opens <details id=...> (FAQ rows, size guide) */
function openHash(h,scroll){
 var el=null;if(!h||h.length<2)return;try{el=d.getElementById(decodeURIComponent(h.slice(1)));}catch(e){}
 if(el&&el.tagName==='DETAILS'){el.open=true;if(scroll)el.scrollIntoView({block:'start'});}
}
d.addEventListener('click',function(e){
 var t=e.target,s,c,box,sw,card,im,pe,a,u;if(!t.closest)return;
 s=t.closest('[data-em-det]>summary');
 if(s){e.preventDefault();if(cur===s.parentNode)closeDet();else openDet(s.parentNode);return;}
 c=t.closest('[data-em-cart-open]');
 if(c&&cd()){e.preventDefault();opener=c;d.dispatchEvent(new CustomEvent('em:cart-open'));return;}
 if(cdOpen&&t.closest('[data-emk-close]')&&cd().contains(t)){e.preventDefault();closeCart();return;}
 if(cur){if(t.closest('[data-em-ov]'))closeDet();else if(!cur.contains(t)||t.closest('a[href]'))closeDet(1);}
 s=t.closest('[data-em-motion] .em-pp');
 if(s){box=s.closest('[data-em-motion]');setPaused(box,!box.classList.contains('is-paused'));}
 sw=t.closest('[data-em-pc-sw]');card=sw&&sw.closest('[data-em-pc]');
 if(card){/* 8 card colour dot: photo (or the card photo again), links, price; no reload */
  im=$('.em-pc__img',card);pe=$('[data-em-pc-price]',card);
  if(im){if(!im._o)im._o=[ga(im,'src'),ga(im,'srcset')||''];u=ga(sw,'data-src');im.srcset=u?ga(sw,'data-srcset')||'':im._o[1];im.src=u||im._o[0];}
  if(ga(sw,'data-url'))$$('[data-em-pc-link]',card).forEach(function(l){l.href=ga(sw,'data-url');});
  if(pe&&ga(sw,'data-price'))pe.textContent=ga(sw,'data-price');
  $$('[data-em-pc-sw]',card).forEach(function(x){x.setAttribute('aria-pressed',x===sw);});
  card.classList.add('is-sw');
 }
 a=t.closest('a[href^="#"]');if(a)openHash(ga(a,'href'),0);
});
d.addEventListener('keydown',function(e){
 if(cdOpen){if(e.key==='Escape')return closeCart();trap(e,tabs($('.em-cd__panel',cd())));return;}
 if(cur){if(e.key==='Escape')return closeDet();trap(e,[cur.querySelector('summary')].concat(tabs($('[data-em-panel]',cur))));}
});
/* 8b card hover photo: loads on the first real mouse hover only (phones never download it) */
var fine=w.matchMedia&&matchMedia('(hover:hover) and (pointer:fine)');
d.addEventListener('pointerover',function(e){
 var c,i;if(e.pointerType!=='mouse'||!fine||!fine.matches||!e.target.closest)return;
 c=e.target.closest('[data-em-pc]');i=c&&!c.classList.contains('is-sw')&&$('.em-pc__img2[data-src]',c);if(!i)return;
 if(ga(i,'data-srcset'))i.srcset=ga(i,'data-srcset');i.src=ga(i,'data-src');i.removeAttribute('data-src');
});
/* 9 recently viewed: handles, newest first, max 8 (the reader leaves out the page it is on) */
var ph=d.body&&ga(d.body,'data-em-product');
if(ph)try{var L=JSON.parse(localStorage.getItem('em_rv')||'[]');if(!Array.isArray(L))L=[];L=L.filter(function(h){return h!==ph;});L.unshift(ph);localStorage.setItem('em_rv',JSON.stringify(L.slice(0,8)));}catch(e){}
/* theme editor (a picked phone-menu row opens the menu) */
d.addEventListener('shopify:section:load',function(e){annEnd();initAnn();initStuck();initHl(e.target);initMq(e.target);giftMin(e.target);});
d.addEventListener('shopify:section:unload',function(){if(cur&&!d.contains(cur)){cur=null;lock(0);}});
d.addEventListener('shopify:block:select',function(e){var m=e.target,a=m.closest&&m.classList.contains('em-ann__m')&&m.closest('[data-em-ann]'),n=m.closest&&m.closest('.em-nav');if(a){a.setAttribute('data-sel','');showMsg(a,m);}if(n&&cur!==n&&!(mq&&mq.matches))openDet(n);});
d.addEventListener('shopify:block:deselect',function(e){var a=e.target.closest&&e.target.closest('[data-em-ann]');if(a)a.removeAttribute('data-sel');if(cur&&e.target.closest&&e.target.closest('.em-nav')===cur)closeDet(1);});
annEnd();giftMin();initAnn();initStuck();initHl();initMq();openHash(location.hash,1);
w.addEventListener('hashchange',function(){openHash(location.hash,1);});
})();
